import { __ } from '@wordpress/i18n';
import { ToolbarGroup, ToolbarButton,DropdownMenu ,Dropdown} from '@wordpress/components';
import {  BlockControls, MediaUpload,URLInput} from '@wordpress/block-editor';
import { GoVideo } from "react-icons/go";
import { FaVideo, FaVimeo,FaYoutube } from 'react-icons/fa';
import {CopyPasteStyles} from '@vayu-blocks';

const BlockControl = ({ attributes, setAttributes, rotateImage }) => {

    const handleSelectVideo = (media) => {
        setAttributes({ videoUrl: media.url,imageaspectratio:{
            Desktop: "",
            Mobile:"",
            Tablet: ""
        },
        videoheight: {
            Desktop: '315px',
            Tablet: '315px',
            Mobile: '315px'
        },
        videowidth: {
            Desktop: '560px',
            Tablet: '560px',
            Mobile: '560px'
        },});
    };

    const vayu_blocks_u_tube_video_change = (url) => {
        // Decode the URL to handle encoded characters like &amp;
        const decodedUrl = decodeURIComponent(url);
    
        // Regex for different types of YouTube URLs
        const youtubeRegexShortened = /(?:https?:\/\/)?(?:www\.)?youtu\.be\/([\w-]{11})(?:\?si=[\w-]+)?/;
        const youtubeRegexStandard = /(?:https?:\/\/)?(?:www\.)?youtube\.com\/(?:watch\?v=|embed\/)([\w-]{11})(?:[^\s]*)?(?:&start=(\d+))?/;
        const iframeRegex = /(?:https?:\/\/)?(?:www\.)?youtube\.com\/embed\/([\w-]{11})\?[^&]*&start=(\d+)/;
        const youtubeRegexShorts = /(?:https?:\/\/)?(?:www\.)?youtube\.com\/shorts\/([\w-]{11})(?:\?si=[\w-]+)?/;
    
        let match, videoId, startTime = null;
    
        // Check for shortened URL (youtu.be)
        match = decodedUrl.match(youtubeRegexShortened);
        if (match) {

            videoId = match[1];

            const startMatch = decodedUrl.match(/t=(\d+)/);
            startTime = startMatch ? startMatch[1] : null; // Extract the start time if present

            if (decodedUrl.match(youtubeRegexShorts)) {
                setAttributes({
                    videowidth: {
                        Desktop: '266px',
                        Tablet: '266px',
                        Mobile: '266px'
                    },
                    videoheight: {
                        Desktop: '473px',
                        Tablet: '473px',
                        Mobile: '473px'
                    },
                    youtubeshorts: true,
                    imageaspectratio:{
                        Desktop: "9/16",
                        Mobile:"9/16",
                        Tablet: "9/16"
                    }
                });
            } else {
                setAttributes({
                    videoheight: {
                        Desktop: '315px',
                        Tablet: '315px',
                        Mobile: '315px'
                    },
                    videowidth: {
                        Desktop: '560px',
                        Tablet: '560px',
                        Mobile: '560px'
                    },
                    youtubeshorts: false,
                    imageaspectratio:{
                        Desktop: "16/9",
                        Mobile:"16/9",
                        Tablet: "16/9"
                    }
                });
            }
            

        } else {
            // Check for standard YouTube URL, iframe URL, or Shorts URL
            match = decodedUrl.match(youtubeRegexStandard) || decodedUrl.match(iframeRegex) || decodedUrl.match(youtubeRegexShorts);
            if (match) {
                videoId = match[1];
                // Extract start time if it's present in the URL
                const startMatch = decodedUrl.match(/start=(\d+)/);
                startTime = startMatch ? startMatch[1] : null; // Extract the start time if present

                if (decodedUrl.match(youtubeRegexShorts)) {
                    setAttributes({
                        videowidth: {
                            Desktop: '266px',
                            Tablet: '266px',
                            Mobile: '266px'
                        },
                        videoheight: {
                            Desktop: '473px',
                            Tablet: '473px',
                            Mobile: '473px'
                        },
                        youtubeshorts: true,
                        imageaspectratio:{
                            Desktop: "9/16",
                            Mobile:"9/16",
                            Tablet: "9/16"
                        }
                    });
                } else {
                    setAttributes({
                        videoheight: {
                            Desktop: '315px',
                            Tablet: '315px',
                            Mobile: '315px'
                        },
                        videowidth: {
                            Desktop: '560px',
                            Tablet: '560px',
                            Mobile: '560px'
                        },
                        youtubeshorts: false,
                        imageaspectratio:{
                            Desktop: "16/9",
                            Mobile:"16/9",
                            Tablet: "16/9"
                        }
                    });
                }
                
            } else {
                // If no valid match is found, clear the video URL and start time
                setAttributes({ youvideoUrl: '', startTime: '',
                    imageaspectratio:{
                        Desktop: "16/9",
                        Mobile:"16/9",
                        Tablet: "16/9"
                    }
                 });
               
                return;
            }
        }
 
        if (startTime !== null) {
            startTime = Number(startTime); // Ensure startTime is a number
        }

        // Save videoId and startTime if valid
        setAttributes({
            youvideoUrl: videoId,
            startTime: startTime
        });
    };

    const vayu_blocks_vimeo_change = (url) => {
        const decodedUrl = decodeURIComponent(url.trim());
    
        // Match all valid Vimeo formats
        const vimeoRegex = /vimeo\.com\/(?:video\/)?(\d+)/;
    
        const match = decodedUrl.match(vimeoRegex);
    
        if (match && match[1]) {
            const videoId = match[1];
    
            setAttributes({
                vimeourl: videoId,
                imageaspectratio:{
                    Desktop: "",
                    Mobile:"",
                    Tablet: ""
                },
                videoheight: {
                    Desktop: '315px',
                    Tablet: '315px',
                    Mobile: '315px'
                },
                videowidth: {
                    Desktop: '560px',
                    Tablet: '560px',
                    Mobile: '560px'
                }, 
            });
        
        } else {
            // Invalid URL
            setAttributes({ vimeourl: '' });
            
        }
    };

    const handleyoutubeselect = () => {
        if(attributes.youtubeshorts){
                setAttributes({ videowidth: {
                    Desktop: '266px',
                    Tablet: '266px',
                    Mobile: '266px'
                },
                videoheight: {
                    Desktop: '473px',
                    Tablet: '473px',
                    Mobile: '473px'
                },
                blockValue: 'you-tube',
                imageaspectratio:{
                    Desktop: "9/16",
                    Mobile:"9/16",
                    Tablet: "9/16"
                }})
        }else{
            setAttributes({
                videoheight: {
                    Desktop: '315px',
                    Tablet: '315px',
                    Mobile: '315px'
                },
                videowidth: {
                    Desktop: '560px',
                    Tablet: '560px',
                    Mobile: '560px'
                },
                blockValue: 'you-tube',
                imageaspectratio:{
                    Desktop: "16/9",
                    Mobile:"16/9",
                    Tablet: "16/9"
                }
            });
        }
    }

    return (
        <>
            <BlockControls>

                {(attributes.videoUrl || attributes.youvideoUrl) && (
                    <ToolbarGroup>
                        <ToolbarButton
                            label="Rotate Image"
                            onClick={rotateImage}
                        >
                            <span
                                style={{
                                    display: 'inline-block',
                                    transform: `rotate(${attributes.rotation}deg)`,
                                    transition: 'transform 0.3s ease-in-out'
                                }}
                                className="dashicons dashicons-image-rotate"
                            ></span>
                        </ToolbarButton>
                    </ToolbarGroup>
                )}

                {attributes.blockValue && (
                    <ToolbarGroup>
                    <DropdownMenu
                        icon={GoVideo}
                        label="Select Video Type"
                        controls={[
                            {
                                title: 'MP4',
                                icon: <FaVideo />,
                                isActive: attributes.blockValue === 'mp4',
                                onClick: () => setAttributes({ blockValue: 'mp4',imageaspectratio:{
                                    Desktop: "",
                                    Mobile:"",
                                    Tablet: ""
                                },
                                videoheight: {
                                    Desktop: '315px',
                                    Tablet: '315px',
                                    Mobile: '315px'
                                },
                                videowidth: {
                                    Desktop: '560px',
                                    Tablet: '560px',
                                    Mobile: '560px'
                                }, }),
                            },
                            {
                                title: 'YouTube',
                                icon: <FaYoutube />,
                                isActive: attributes.blockValue === 'you-tube',
                                onClick: handleyoutubeselect,
                            },
                            {
                                title: 'Vimeo',
                                icon: <FaVimeo />,
                                isActive: attributes.blockValue === 'vimeo',
                                onClick: () => setAttributes({ blockValue: 'vimeo',imageaspectratio:{
                                    Desktop: "",
                                    Mobile:"",
                                    Tablet: ""
                                },
                                videoheight: {
                                    Desktop: '315px',
                                    Tablet: '315px',
                                    Mobile: '315px'
                                },
                                videowidth: {
                                    Desktop: '560px',
                                    Tablet: '560px',
                                    Mobile: '560px'
                                }, }),
                            },
                        ]}
                    />
                </ToolbarGroup>
                )}

                {attributes.blockValue === 'mp4' && (
                    <ToolbarGroup>
                        <MediaUpload
                            onSelect={handleSelectVideo}
                            allowedTypes={['video']}
                            render={({ open }) => (
                                <ToolbarButton
                                    label="Replace Video"
                                    onClick={open}
                                >
                                    {__('Replace', 'vayu-blocks')}
                                </ToolbarButton>
                            )}
                        />
                    </ToolbarGroup>
                )}

                {attributes.blockValue === 'you-tube' && (
                    <ToolbarGroup>
                    <Dropdown
                        className="vayu-blcoks-video-dropdown"
                        contentClassName="vayu-blcoks-video-dropdown-content"
                        position="bottom right"
                        renderToggle={({ isOpen, onToggle }) => (
                            <ToolbarButton
                                label={__('Change YouTube Video URL', 'vayu-blocks')}
                                onClick={onToggle}
                                aria-expanded={isOpen}
                            >
                                {__('Replace', 'vayu-blocks')}
                            </ToolbarButton>
                        )}
                        renderContent={() => (
                            <div style={{ padding: '10px', width: '260px' }}>
                                <URLInput
                                    label={__('Enter YouTube URL', 'vayu-blocks')}
                                    onChange={vayu_blocks_u_tube_video_change}
                                    placeholder="https://youtu.be/abc123xyz"
                                />
                            </div>
                        )}
                    />
                </ToolbarGroup>
                )}

                {attributes.blockValue === 'vimeo' && (
                    <ToolbarGroup>
                        <Dropdown
                            className="vayu-blcoks-video-dropdown"
                            contentClassName="vayu-blcoks-video-dropdown-content"
                            position="bottom right"
                            renderToggle={({ isOpen, onToggle }) => (
                                <ToolbarButton
                                    label={__('Change Vimeo URL', 'vayu-blocks')}
                                    onClick={onToggle}
                                    aria-expanded={isOpen}
                                >
                                    {__('Replace', 'vayu-blocks')}
                                </ToolbarButton>
                            )}
                            renderContent={() => (
                                <div style={{ padding: '10px', width: '260px' }}>
                                    <URLInput
                                        label={__('Enter vimeo URL', 'vayu-blocks')}
                                        onChange={vayu_blocks_vimeo_change}
                                        placeholder="https://vimeo.com/abc123xyz"
                                    />
                                </div>
                            )}
                        />
                    </ToolbarGroup>
                )}

                <ToolbarGroup>
                    <CopyPasteStyles exclude={['blockValue', 'videoUrl','youvideoUrl', 'youtubeshorts', 'vimeourl' ]} attributes={attributes} setAttributes={setAttributes} blockName={'vayu-blocks/video'}/>
                </ToolbarGroup>
         
             </BlockControls>

        </>
    );
};

export default BlockControl;
